__turbopack_context__.v({
  "addressColumn": "FooterCS-module-scss-module__dKLola__addressColumn" + " " + "FooterCS-module-scss-module__dKLola__footerColumn",
  "adminColumn": "FooterCS-module-scss-module__dKLola__adminColumn" + " " + "FooterCS-module-scss-module__dKLola__footerColumn",
  "blocksBackgroundColor": "FooterCS-module-scss-module__dKLola__blocksBackgroundColor",
  "blocksFontColor": "FooterCS-module-scss-module__dKLola__blocksFontColor",
  "descriptionColumn": "FooterCS-module-scss-module__dKLola__descriptionColumn" + " " + "FooterCS-module-scss-module__dKLola__footerColumn",
  "followFooter": "FooterCS-module-scss-module__dKLola__followFooter",
  "footerColumn": "FooterCS-module-scss-module__dKLola__footerColumn",
  "footerContactInfo": "FooterCS-module-scss-module__dKLola__footerContactInfo",
  "footerText": "FooterCS-module-scss-module__dKLola__footerText",
  "footerTextSaveIcon": "FooterCS-module-scss-module__dKLola__footerTextSaveIcon",
  "footerTextSaveIconDidSave": "FooterCS-module-scss-module__dKLola__footerTextSaveIconDidSave",
  "mainFooter": "FooterCS-module-scss-module__dKLola__mainFooter",
  "mainFooterContentWell": "FooterCS-module-scss-module__dKLola__mainFooterContentWell",
  "navColumn": "FooterCS-module-scss-module__dKLola__navColumn" + " " + "FooterCS-module-scss-module__dKLola__footerColumn",
  "navContainer": "FooterCS-module-scss-module__dKLola__navContainer",
  "organizationInfo": "FooterCS-module-scss-module__dKLola__organizationInfo",
  "secondaryNavBackgroundColor": "FooterCS-module-scss-module__dKLola__secondaryNavBackgroundColor",
  "socialColumn": "FooterCS-module-scss-module__dKLola__socialColumn" + " " + "FooterCS-module-scss-module__dKLola__footerColumn",
  "themeBackgroundColor": "FooterCS-module-scss-module__dKLola__themeBackgroundColor",
  "themeFontColor": "FooterCS-module-scss-module__dKLola__themeFontColor",
  "themeFontFamily": "FooterCS-module-scss-module__dKLola__themeFontFamily",
});
